import React from "react";
import { bool, func, string } from "prop-types";
import SpacedOutText from "../common/SpacedOutText";
import OptionsButton from "../common/OptionsButton";
import { TextAreaGroup } from "../common";

const Convictions = ({ value, handleChange, criminalConvictionDetails }) => {
  return (
    <div className="m-md-2 mt-2">
      <SpacedOutText>
        Do you have any unspent conditional cautions or convictions under the
        Rehabilitation of Offenders Act 1794 OR convictions or cautions
        (excluding youth cautions, reprimands or warning) that are not
        &apos;protected&apos; as defined by the{" "}
        <a
          href="https://www.gov.uk/government/publications/new-guidance-on-the-rehabilitation-of-offenders-act-1974"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ministry of Justice
        </a>
        ?
      </SpacedOutText>
      <div className="btn-group clearfix d-block">
        <OptionsButton
          items={[
            {
              text: "Yes",
              key: "criminalConviction",
              value: true,
              isActive: value === true,
            },
            {
              text: "No",
              key: "criminalConviction",
              value: false,
              isActive: value === false,
            },
          ]}
          handleChange={handleChange}
        />
      </div>
      {value && (
        <div className="form-group mt-1">
          <label htmlFor="criminalConvictionDetails">
            Please state below along with any other information relevant to the
            caution or conviction (e.g. paid or unpaid work as rehabilitation):
          </label>
          <TextAreaGroup
            inputName="criminalConvictionDetails"
            value={criminalConvictionDetails || ""}
            onChange={(e) =>
              handleChange("criminalConvictionDetails", e.target.value)
            }
            resizable={false}
          />
        </div>
      )}
    </div>
  );
};

Convictions.propTypes = {
  value: bool,
  handleChange: func,
  criminalConvictionDetails: string,
};

export default Convictions;
